const CONSTANTS = {
 API_URL: 'https://insurancecrm.crystalauto.co.in',
  publicVapidKey: 'BHar8mMOW2JOSM37IQcHphtHytCHeIY86qvUaoFJdvypSllGSFuc4QSvXxnWtgyVYQBOOZsQPcW64W7V07mRCLc',
  googleMapsAPIKey: 'AIzaSyCN2hFrFD4wZHNVA8RwKdN-lQ8ph8u8SS4',
  defaultCenter: {
    lat: 20.7493472,
    lng: 78.5759262
  },
  center: {
    lat: 20.7493472,
    lng: 78.5759262
  },
  defaultZoom: 10
};

// function getCurrentLocation(position) {//eslint-disable-line
//   CONSTANTS.defaultCenter = {
//     // lat: Number(position.coords.latitude.toFixed(7)),
//     // lng: Number(position.coords.longitude.toFixed(7))
//     lat: 20.7493472,
//     lng: 78.5759262
//   };
// }

// (function getGeoLocation() {
//   if (navigator.geolocation) {
//     navigator.geolocation.getCurrentPosition(getCurrentLocation);
//   } else {
//     alert('Geolocation is not supported by this browser.');
//   }
// })();

export default CONSTANTS;
